import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import Loader from "./components/loader";
import { useSelector } from "react-redux";
import Login from "./pages/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Customers from "./pages/customers/Customers";
import GoldLoan from "./pages/GoldLoan";
import Reports from "./pages/Reports";
import Accounting from "./pages/Accounting";
import Inventory from "./pages/Inventory";
import Settings from "./pages/Settings";
import Repayments from "./pages/Repayments";
import Billing from "./pages/Billing";
import NotAuthorized from "./pages/NotAuthorized";
import UserRoles from "./pages/admin/UserRoles";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { getHomeRouteByRole } from "./utils/authRoles";

import { Toaster } from "react-hot-toast";

function DefaultRoute() {
  const { authUser, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getHomeRouteByRole(authUser.role)} replace />;
}

function App() {
  const loading = useSelector((state) => state.loader.loading);
  return (
    <BrowserRouter>
      <AuthProvider>
        {loading && <Loader />}
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<DefaultRoute />} />
          <Route path="/login" element={<Login />} />
          <Route path="/not-authorized" element={<NotAuthorized />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route
                element={<ProtectedRoute requiredRole={["admin", "subadmin"]} />}
              >
                <Route path="/customers" element={<Customers />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/billing" element={<Billing />} />
              </Route>

              <Route element={<ProtectedRoute requiredRole="admin" />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/goldloan" element={<GoldLoan />} />
                <Route path="/accounting" element={<Accounting />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/repayments" element={<Repayments />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/admin/user-roles" element={<UserRoles />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;